import {
  Component,
  EventEmitter,
  Injector,
  OnInit,
  Output,
} from '@angular/core';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  FormDefinitionBasicDto,
  FormDefinitionDto,
  FormsServiceProxy,
} from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-activities-forms-panel',
  templateUrl: './activities-forms-panel.component.html',
  styleUrls: ['./activities-forms-panel.component.scss'],
  providers: [FormsServiceProxy],
})
export class ActivitiesFormsPanelComponent
  extends AppComponentBase
  implements OnInit
{
  constructor(
    private _projectService: ProjectService,
    private _formServiceProxy: FormsServiceProxy,
    injector: Injector
  ) {
    super(injector);
  }
  isOpenListOfForms = false;
  formsList: FormDefinitionBasicDto[] = [];
  @Output() onOpenDefaultForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpenFormPanel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreated: EventEmitter<any> = new EventEmitter<any>();

  selectedForm: FormDefinitionDto;
  openDefaultActivityForm() {
    this.onOpenDefaultForm.emit();
  }
  
  openFormPanel() {
    this.selectedForm = null;
  }

  activityCreated() {
    this.onCreated.emit();
  }

  async ngOnInit() {
    this._formServiceProxy
      .getFormDefinitionsBasic(true, 1000, 0)
      .subscribe((x) => {
        this.formsList = x.items;
      });
  }
  @Output() onClosePanel: EventEmitter<any> = new EventEmitter<any>();

  goback() {
    this.onClosePanel.emit();
  }
  closeDrawer() {
    this.onClosePanel.emit();
  }

  onClick(selectedForm: FormDefinitionDto) {
    this.selectedForm = selectedForm;
  }
}
